import React from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Grid,
  Divider,
  Tooltip
} from "@mui/material";
import { IoArrowBackOutline } from "react-icons/io5";
import { TbExternalLink } from "react-icons/tb";
import { InsertPhoto, PictureAsPdf } from "@mui/icons-material";

const PRIMARY_COLOR = "#286a94";

function ViewCertificate({ setViewCer, data }) {
  return (
    <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: 2,
        }}
      >
        <IconButton onClick={() => setViewCer(false)} sx={{ color: PRIMARY_COLOR }}>
          <IoArrowBackOutline size={24} />
        </IconButton>
        <Typography variant="h6" fontWeight={600} color={PRIMARY_COLOR}>
          Certification Details
        </Typography>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* Details Grid */}
      <Grid container spacing={2}>
        {[
          { label: "Certification ID", value: data.certificationId },
          { label: "Course Name", value: data.courseName },
          { label: "Duration", value: data.duration },
          { label: "Course Provider", value: data.courseProvider },
          { label: "Completion Year", value: data.year },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "#6b7280" }}>
              {item.label}
            </Typography>
            <Typography
              variant="body1"
              sx={{ mt: 0.5, fontWeight: 500, color: "#111827" }}
            >
              {item.value || "N/A"}
            </Typography>
          </Grid>
        ))}

        {data?.certificationUrl && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "#6b7280" }}>
              Certificate Link
            </Typography>
            <Tooltip title="Open Certification URL">
              <IconButton
                href={data.certificationUrl}
                target="_blank"
                rel="noreferrer"
                sx={{ mt: 1, color: PRIMARY_COLOR }}
              >
                <TbExternalLink size={24} />
              </IconButton>
            </Tooltip>
          </Grid>
        )}

        {data?.imgUrl && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "#6b7280" }}>
              Certificate File
            </Typography>
            <Tooltip title="Open File">
              <IconButton
                href={data.imgUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mt: 1, color: PRIMARY_COLOR }}
              >
                {data.imgUrl.toLowerCase().endsWith(".pdf") ? (
                  <PictureAsPdf />
                ) : (
                  <InsertPhoto />
                )}
              </IconButton>
            </Tooltip>
          </Grid>
        )}
      </Grid>

      {/* Preview Image Section */}
      {data?.imgUrl && !data?.imgUrl.toLowerCase().endsWith(".pdf") && (
        <Box sx={{ mt: 3, textAlign: "center" }}>
          <Typography variant="body2" fontWeight={600} sx={{ color: "#6b7280", mb: 1 }}>
            Preview
          </Typography>
          <img
            src={data.imgUrl}
            alt="Certificate"
            style={{
              width: "80%",
              maxWidth: "400px",
              borderRadius: "10px",
              boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
            }}
          />
        </Box>
      )}
    </Paper>
  );
}

export default ViewCertificate;
